module.exports = __webpack_public_path__ + "img/squirrel.27d91257.svg";